import { Component, inject, OnInit } from '@angular/core';
import { Auth } from '../../services/auth';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-verify',
  standalone: false,
  templateUrl: './verify.html',
  styleUrl: './verify.less'
})
export class Verify implements OnInit {
  userId: any;
  verified: boolean = false;
  loading: boolean = true;
  private authService = inject(Auth);
  constructor(
    private route: ActivatedRoute,
  ) {

  }

  ngOnInit(): void {
    this.userId = this.route.snapshot.paramMap.get('id') || '';
    console.log('Verification ID:', this.userId);
    this.verifyUser();
  }

  verifyUser() {
    this.authService.verifyUser(this.userId)
      .subscribe({
        next: (data: any) => {
          if (data.status == 'Verified') {
            this.verified = true;
          } else {
            this.verified = false;
          }
          this.loading = false;
        },
        error: (error: any) => {
          console.log(error);
          this.loading = false;
        }
      })
  }
}
